import Alert from "@shared/v2/Alert";
import Typography from "@shared/v2/Typography";
import { ChevronRightSolidV6, CircleInfoSolidV6 } from "@shared/v2/Icomoon";
import { AccountProduct, Product } from "../../../../Support/Account/AddOnsSupport/types";
import UpDownProductInfo from "./UpDownProductInfo";

interface Step1Props {
  accountProduct?: AccountProduct;
  newProduct?: Product;
  next: "up" | "down";
}

const Step1 = ({ accountProduct, newProduct, next }: Step1Props) => (
  <>
    <div className="tw-px-[8px] tw-flex tw-items-center tw-gap-[24px]">
      <UpDownProductInfo product={accountProduct?.product as Product} />
      <ChevronRightSolidV6 size="l" className="tw-flex-none tw-text-gray-50" />
      <UpDownProductInfo product={newProduct} next={next} />
    </div>
    <div className="tw-flex tw-flex-col tw-gap-[8px]">
      {/* @ts-expect-error props */}
      <Typography variant="subtitle-m-bold">Payment Method</Typography>
      {/* @ts-expect-error props */}
      <Typography>
        We’ll use the same payment method you’re currently using for Phone System. To update this, please
        contact support.
      </Typography>
    </div>
    <div className="tw-flex tw-flex-col tw-gap-[16px]">
      {/* @ts-expect-error props */}
      <Typography variant="subtitle-m-bold">Billing Changes</Typography>
      <Alert
        icon={<CircleInfoSolidV6 size="l" className="tw-text-gray-50" />}
        variant="gray"
        title="How does this affect my minutes and overages?"
        text="The plan will take into effect immediately. Any overages accrued for this billing period will be billed on the new plan’s rates. Pro-rated charge will be added to your next bill."
      />
    </div>
    <div className="tw-px-[24px] tw-py-[16px] tw-rounded-[8px] tw-shadow-card tw-flex tw-flex-col tw-gap-[16px]">
      {/* <div className="tw-flex tw-justify-between">
        <span>Pro-rated charge for this billing period</span>
        <Typography variant="subtitle-m">$10.00</Typography>
      </div> */}
      <div className="tw-flex tw-justify-between">
        <span>{newProduct?.tier} Plan for next billing period</span>
        {/* @ts-expect-error props */}
        <Typography variant="subtitle-m">${newProduct?.details.unitPrice.toFixed(2)}</Typography>
      </div>
      {/* <div className="tw-flex tw-justify-between">
        <span>Taxes and Fees</span>
        <Typography variant="subtitle-m">$10.00</Typography>
      </div> */}
      <hr className="tw-m-0 tw-p-0 tw-border-gray-10" />
      <div className="tw-flex tw-justify-between">
        <div className="tw-flex tw-flex-col tw-gap-[2px]">
          <div className="tw-flex tw-gap-[6px]">
            {/* @ts-expect-error props */}
            <Typography variant="subtitle-m">Next Bill Total</Typography>
            on MM/DD/YYYY
          </div>
          <div className="tw-text-gray-50">Additional overages may apply based on usage</div>
        </div>
        {/* @ts-expect-error props */}
        <Typography variant="headline2">${newProduct?.details.unitPrice.toFixed(2)}</Typography>
      </div>
    </div>
  </>
);

export default Step1;
